import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrderRerun } from '../../types/api/response/orderrerunsresponse';
import { IOrderRerunsFilters, IOrderRerunsState } from '../../types/store';

const initialState: IOrderRerunsState = {
  reruns: [],
  totalElements: 0,
  filters: {
    source: null,
    search: '',
  },
  pagination: { page: 0, size: 20 },
  selectedRerun: null,
};

const orderRerunsSlice = createSlice({
  name: 'orderRerunsSlice',
  initialState,
  reducers: {
    setOrderReruns: (
      state,
      action: PayloadAction<{ content: IOrderRerun[]; totalElements: number }>,
    ) => {
      state.reruns = action.payload.content;
      state.totalElements = action.payload.totalElements;
    },
    setSelectedRerun: (state, action: PayloadAction<IOrderRerun | null>) => {
      state.selectedRerun = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<IOrderRerunsFilters>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPagination: (state, action: PayloadAction<{ page: number; size: number }>) => {
      state.pagination = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.reruns = [];
      state.totalElements = 0;
      state.pagination = initialState.pagination;
      state.selectedRerun = null;
    },
  },
});

export const { setOrderReruns, setSelectedRerun, setFilters, setPagination, resetFilters } =
  orderRerunsSlice.actions;

export default orderRerunsSlice.reducer;
